<template>
  <v-container
    id="detalhe-melhores-entregasleite-linhasleite"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <v-row v-if="!paginaEnable">
      <h1>
        Usuário não tem permissão a essa página não existente
      </h1>
    </v-row>
    <v-row v-else>
      <v-col
        cols="12"
        lg="12"
        class="px-1"
      >
        <v-row>
          <v-col
            cols="12"
            class="container"
            style="max-width: 100%"
          >
            <v-container>
              <v-card>
                <v-col
                  cols="12"
                >
                  <v-row>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                      lg="2"
                    >
                      <v-menu
                        ref="menu"
                        v-model="menu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="computedPrimeiroDia"
                            label="Data Inical"
                            persistent-hint
                            prepend-icon="mdi-calendar"
                            v-bind="attrs"
                            readonly
                            v-on="on"
                          />
                        </template>
                        <v-date-picker
                          v-model="primeiroDia"
                          no-title
                          @input="menu = false"
                        />
                      </v-menu>
                    </v-col>
                    <v-col
                      id="menu1"
                      cols="12"
                      sm="6"
                      md="4"
                      lg="2"
                    >
                      <v-menu
                        v-model="menu1"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="computedDateFormatted"
                            label="Data Final"
                            persistent-hint
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                          />
                        </template>
                        <v-date-picker
                          v-model="ultimoDia"
                          no-title
                          @input="menu1 = false"
                        />
                      </v-menu>
                    </v-col>
                    <v-col
                      id="selectEmpresa"
                      cols="12"
                      sm="6"
                      md="4"
                      lg="3"
                    >
                      <v-select
                        v-model="select"
                        :items="empresa"
                        item-value="id"
                        item-text="nomeExibicao"
                        label="Empresas"
                        multiple
                        return-object
                      />
                    </v-col>
                    <v-col
                      id="selectEmpresa"
                      cols="12"
                      sm="6"
                      md="4"
                      lg="3"
                    >
                      <v-select
                        v-model="selectProdutores"
                        :items="produtor"
                        item-value="id"
                        item-text="produtor"
                        label="Produtores"
                        multiple
                        return-object
                      >
                        <template v-slot:selection="{ item, index }">
                          <v-chip v-if="index === 0">
                            <span>{{ item.produtor }}, </span>
                          </v-chip>
                          <v-chip v-if="index === 1">
                            <span>{{ item.produtor }}, </span>
                          </v-chip>
                          <span
                            v-if="index === 2"
                            class="grey--text text-caption"
                          >
                            (+{{ selectProdutores.length - 2 }} outros)
                          </span>
                        </template>
                      </v-select>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                      lg="2"
                    >
                      <v-btn
                        id="btnRefazer"
                        class="col-12 lg-12 text-h4"
                        small
                        :color="corPrimaria"
                        dark
                        @click="updateDate()"
                      >
                        <v-icon>
                          mdi-reload-alert
                        </v-icon>
                        Refazer
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-card>
            </v-container>
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
              >
                <v-card-title
                  id="linhaSelecionada"
                  text-center
                >
                  Linha de Leite: {{ linha.nome_linha }}
                </v-card-title>
                <v-divider class="mb-5" />
                <div>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    lg="12"
                  />
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :componente-auxiliar="true"
                    :text="'Relatório de Compras de leite do Ano Acumulado detalhado por linha'"
                    :padding="dynamicPaddingBloco"
                    :texto-information="textoDetalhesMelhoresEntregas"
                    :code-information="'349'"
                    :exibir-informacao="true"
                    :headers-detalhamento="headersDetalhamento"
                    :dados-detalhamento="dadosDetalhamento"
                    :variacao-diferenca="true"
                    :variacao-qtd="true"
                  />
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </v-container>
</template>

<script>
  import Entregaleite from '../../../../../services/entregaleite'

  export default {
    name: 'DashboardMelhoresEntregasLeiteLinhasLeite',
    components: {
      DashboardCoreSnackbar: () => import('../../../components/core/Snackbar'),
      DashoardCardView: () => import('../../../components/core/CardView.vue'),
    },
    data: () => ({
      appOnline: navigator.onLine,
      corPrimaria: localStorage.corPrimaria,
      corSecondaria: localStorage.corSecondaria,
      styleObjectIcon: {
        color: '#4780b8',
      },
      styleObject: {
        color: localStorage.corPrimaria,
      },
      paginaEnable: false,
      primeiroDia: (new Date(localStorage.dataInicial)).toISOString().substr(0, 10),
      ultimoDia: (new Date(localStorage.dataFinal)).toISOString().substr(0, 10),
      select: JSON.parse(localStorage.getItem('empresaSelect')),
      empresa: [],
      selectProdutores: [],
      produtor: [],
      menu: false,
      menu1: false,
      loading: false,
      linha: null,
      error: null,
      codigo: 0,
      orientacao: [],
      // link: window.location.href,
      textoDetalhesMelhoresEntregas: '',
      headersDetalhamento: [
        { text: 'Produtor', value: 'produtor', align: 'left', class: 'black--text title' },
        { text: 'Quantidade de leite ano anterior(Litros)', value: 'quantidade_anterior', align: 'right', class: 'black--text title' },
        { text: 'Quantidade de leite(Litros)', value: 'quantidade_atual', align: 'right', class: 'black--text title' },
        { text: 'Diferença (Litros)', value: 'diferenca_anual', align: 'right', class: 'black--text title' },
        { text: 'Variação qtd. anual (%)', value: 'varicao_quantidade', align: 'right', class: 'black--text title' },
        { text: 'Preço médio', value: 'precomedio', align: 'right', class: 'black--text title' },
      ],
      dadosDetalhamento: [],
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      dynamicPaddingBloco: '',
    }),

    computed: {
      computedDateFormatted () {
        return this.formatDate(this.ultimoDia)
      },

      computedPrimeiroDia () {
        return this.formatDatePrimeiroDia(this.primeiroDia)
      },
    },
    created () {
      this.linha = this.$route.params.item
    },
    mounted () {
      window.scrollTo(0, 0)
      if (localStorage.tokencontrato) {
        this.usuarioIdentificado = true

        this.paginaEnable = true

        this.orientacao = JSON.parse(localStorage.getItem('orientacaoProdutor'))

        if (typeof this.linha === 'undefined') {
          this.linha = JSON.parse(localStorage.getItem('linhaleite'))
        }

        Entregaleite.showFiltroPorLinhas(localStorage.tokencontrato, this.linha).then(resposta => {
          if (resposta.data.status) {
            var i = 0
            for (i in resposta.data.empresas) {
              this.empresa.push(resposta.data.empresas[i])
            }

            for (i in resposta.data.produtores) {
              this.produtor.push(resposta.data.produtores[i])
            }
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        })
        this.updateDate()
      } else {
        this.usuarioIdentificado = false
        localStorage.removeItem('username')
        localStorage.removeItem('email')
        localStorage.removeItem('nome')
        localStorage.removeItem('usuarioIdentificado')
        this.$router.push('/login')
      }

      if (localStorage.updateDadosFiltros) {
        this.primeiroDia = localStorage.getItem('dataInicial')
        this.date = localStorage.getItem('dataFinal')
        if (localStorage.getItem('empresaSelect') !== null) {
          this.select = JSON.parse(localStorage.getItem('empresaSelect'))
        }
      }

      this.enableTexto('360')
      this.updateDynamicPadding()
    },

    methods: {
      formatDate (date) {
        if (!date) {
          return null
        }

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDatePrimeiroDia (date) {
        if (!date) {
          return null
        }

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      parseDate (date) {
        if (!date) return null

        const [month, day, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },
      enableTexto (value) {
        var i = 0

        this.codigo = value
        for (i in this.orientacao) {
          if (this.orientacao[i].codigo === '360') {
            this.textoDetalhesMelhoresEntregas = this.orientacao[i].descricao
          }
          return this.textoDetalhesMelhoresEntregas
        }
      },

      updateDate () {
        this.dadosDetalhamento = []
        this.showDelhamentoEntregasLinhaLeite()
      },

      async showDelhamentoEntregasLinhaLeite () {
        this.loading = true
        await Entregaleite.showDelhamentoEntregasLinhaLeite(this.primeiroDia, this.ultimoDia, this.select, this.selectProdutores, localStorage.tokencontrato, this.linha).then(resposta => {
          if (resposta.data.status) {
            this.paginaEnable = true
            this.dadosDetalhamento = resposta.data.detalhamentoEntregaLeiteLinha.map((item) => {
              var listaDetalhamento = ({
                produtor: item.nome_produtor,
                quantidade_atual: this.formateNum(item.quantidade_atual),
                quantidade_anterior: this.formateNum(item.quantidade_anterior),
                diferenca_anual: item.quantidade_atual - item.quantidade_anterior,
                varicao_quantidade: item.varicao_quantidade.toFixed(2).toString().replace('.', ',') + '%',
                precomedio: item.precocota.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
              })
              return listaDetalhamento
            })
          } else if (resposta.data.msg === 'Não há dados para o filtro selecionado') {
            this.dadosDetalhamento = []

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          console.error('error', e.message)
          if (e.message === 'Network Error') {
            this.error = e.message

            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loading = false })
      },
      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
      getColor (value) {
        var porcentagem = parseFloat(value.replace(',', '.'))

        return porcentagem >= 100 ? 'color: green' : 'color: red'
      },
      updateDynamicPadding () {
        if (window.innerWidth > 1800) {
          this.dynamicPaddingBloco = 'padding-right: 16rem !important'
        } else if (window.innerWidth > 1380 && window.innerWidth <= 1800) {
          this.dynamicPaddingBloco = 'padding-right: 59rem !important'
        } else if (window.innerWidth > 1000 && window.innerWidth <= 1380) {
          this.dynamicPaddingBloco = 'padding-right: 58rem !important'
        } else if (window.innerWidth > 600 && window.innerWidth <= 1000) {
          this.dynamicPaddingBloco = 'padding-right: 32rem !important'
        } else if (window.innerWidth > 380 && window.innerWidth < 600) {
          this.dynamicPaddingBloco = 'padding-right: 4rem !important'
        } else {
          this.dynamicPaddingBloco = 'padding-right: 55rem !important'
        }
      },
      formateNum (num) {
        return num.toLocaleString('pt-BR', { maximumFractionDigits: 0 })
      },
    },
  }
</script>
<style scoped>
  #linhaSelecionada {
    margin-left: 35rem;
  }
  .red-row {
    background-color: red !important;
    color: white;
  }

  .green-row {
    background-color: green !important;
    color: white;
  }

  /* Estilos para telas menores, como dispositivos móveis */
  @media screen and (max-width: 768px) {
      #linhaSelecionada {
          margin-left: auto;
          margin-right: auto;
          text-align: center !important;
          width: 80%;
      }
  }
</style>
<style lang="sass">
  // #bloco1
    // margin-left: -5rem

  #relatorioProdutoresAtivos
    margin-left: 0.5rem
    font-size: 14px
    font-weight: bold

  #iconInformationMelhoresProdutores
    margin-left: 9.5rem
    font-weight: bold

  #headersMelhoresProdutores
    margin-left: 1.7rem
    margin-right: 1.7rem

  .custom-loader
    animation: loader 1s infinite
    display: flex
    @-moz-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
    @-webkit-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
    @-o-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
    @keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)

</style>
